import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getNewsById } from "../../app/api";
import { useNavigate, useParams } from "react-router-dom";
import NewsSlider from "./news-slider";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const HTMLTextView = ({ htmlContent }: any) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

const settings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

export enum NewsType {

  image = "Зураг",
  video = "Бичлэг",
  reminder = "Санамж",
  notice = "Зарлал",

}


export interface INews {
  title: string;
  subtitle: string;
  content: string;
  thumb: string;
  images: [string];
  type: NewsType;
  videoUrl: string;
  createAdmin: string;
  updateAdmin: string;
  status: boolean;
  createdAt?: string;
}

export default function NewsDetail() {
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState<INews>({} as INews);
  const [images, setImages] = useState<any>([]);

  const params = useParams();

  useEffect(() => {
    setLoading(true);
    getNewsById(params.id).then((res) => {
      setNews(res.data);
      if (res.data.images && res.data.images.length > 0) {
        setImages(res.data.images.map((image: any) => {
          return {
            original: image,
            thumbnail: image,
          };
        }));
      }
      setLoading(false);
    }).catch((err) => {
      console.error(err);
      setLoading(false);
    });
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;

    // Add custom styles for image gallery
    const styleId = 'news-detail-gallery-styles';
    let style = document.getElementById(styleId) as HTMLStyleElement;

    if (!style) {
      style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .image-gallery-slide img {
          width: 100%;
          height: 600px;
          object-fit: cover;
        }
        .image-gallery-thumbnail img {
          width: 100%;
          height: 80px;
          object-fit: cover;
        }
        .image-gallery-thumbnail {
          width: 120px !important;
          height: 80px !important;
        }
        .image-gallery-thumbnail.active {
          border: 2px solid #2563EB;
        }
        @media (max-width: 768px) {
          .image-gallery-slide img {
            height: 400px;
          }
          .image-gallery-thumbnail img {
            height: 60px;
          }
          .image-gallery-thumbnail {
            width: 80px !important;
            height: 60px !important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    return () => {
      const styleToRemove = document.getElementById(styleId);
      if (styleToRemove) {
        document.head.removeChild(styleToRemove);
      }
    };
  }, [params.id]);

  return (
    <>
      {loading && (
        <div className="w-full h-full fixed top-0 left-0 bg-white/95 z-50 flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-neutral-200 border-t-neutral-800 rounded-full animate-spin"></div>
        </div>
      )}

      {/* Dark hero with article header */}
      <div className="relative overflow-hidden bg-[#0a1628] -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/15 blur-[100px]" />
        </div>
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
        <div className="relative pt-40 pb-12 sm:pt-48 sm:pb-16">
          <div className="max-w-[728px] mx-auto px-6">
            <h1 className="text-[32px] sm:text-[42px] font-extrabold text-white leading-[1.15] tracking-tight mb-4">
              {news.title}
            </h1>
            {news.subtitle && (
              <p className="text-xl sm:text-[22px] text-slate-400 leading-relaxed mb-6 font-normal">
                {news.subtitle}
              </p>
            )}
            <div className="flex items-center gap-3 py-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-warm-500 to-primary-600 flex items-center justify-center text-white text-sm font-bold">
                N
              </div>
              <div className="flex flex-col">
                <span className="text-sm font-medium text-white">Найрамдал</span>
                <div className="flex items-center gap-2 text-sm text-slate-400">
                  <time>
                    {news.createdAt && `${new Date(news.createdAt).getFullYear()}.${String(new Date(news.createdAt).getMonth() + 1).padStart(2, '0')}.${String(new Date(news.createdAt).getDate()).padStart(2, '0')}`}
                  </time>
                  {news.type && (
                    <>
                      <span>·</span>
                      <span>{news.type}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* White content area */}
      <div className="min-h-screen bg-white">
        {/* Actions bar */}
        <div className="max-w-[728px] mx-auto px-6">
          <div className="flex items-center justify-between py-3 border-y border-neutral-100 my-6">
            <div className="flex items-center gap-4 text-neutral-400">
              <button className="flex items-center gap-1.5 hover:text-neutral-600 transition-colors">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Hero Image/Video - Full width within container */}
        <div className="max-w-[944px] mx-auto px-6 mb-10">
          <figure>
            <div className="relative -mt-6">
              <div className="absolute -inset-4 bg-gradient-to-r from-warm-500/10 via-transparent to-primary-500/10 rounded-2xl blur-2xl" />
              <div className="relative w-full overflow-hidden bg-neutral-100 rounded-sm">
                {news.videoUrl ? (
                  <div className="relative w-full aspect-video bg-black">
                    <iframe
                      src={`https://www.youtube.com/embed/${news.videoUrl.split("v=")[1].split("&")[0]}`}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Video"
                      className="absolute inset-0 w-full h-full"
                    />
                  </div>
                ) : (
                  <img
                    className="w-full h-auto object-cover"
                    src={news.thumb}
                    alt={news.title}
                  />
                )}
              </div>
            </div>
          </figure>
        </div>

        {/* Article Body - Medium narrow column */}
        <article className="max-w-[728px] mx-auto px-6">
          <div className="prose prose-lg sm:prose-xl max-w-none">
            <div className="text-neutral-700 leading-[1.8] text-lg sm:text-[20px] [&>p]:mb-7 [&>h2]:text-2xl [&>h2]:font-bold [&>h2]:text-neutral-900 [&>h2]:mt-12 [&>h2]:mb-4 [&>h3]:text-xl [&>h3]:font-bold [&>h3]:mt-8 [&>h3]:mb-3 [&>img]:rounded-sm [&>img]:my-10 [&>ul]:my-4 [&>ol]:my-4 [&>blockquote]:border-l-4 [&>blockquote]:border-neutral-900 [&>blockquote]:pl-5 [&>blockquote]:italic [&>blockquote]:text-neutral-600 [&>blockquote]:my-8">
              <HTMLTextView htmlContent={news.content} />
            </div>
          </div>
        </article>

        {/* Image Gallery Section */}
        {news.images && news.images.length > 0 && (
          <div className="max-w-[944px] mx-auto px-6 mt-16">
            <div className="pt-10 border-t border-neutral-100">
              <h2 className="text-2xl font-extrabold text-neutral-900 mb-8">
                Зургийн цомог
              </h2>
              <div className="w-full rounded-sm overflow-hidden">
                <ImageGallery
                  items={images}
                  showPlayButton={false}
                  showFullscreenButton={true}
                  showBullets={true}
                  showThumbnails={true}
                  thumbnailPosition="bottom"
                  slideInterval={3000}
                />
              </div>
            </div>
          </div>
        )}

        {/* Bottom spacer */}
        <div className="h-16"></div>
      </div>

      {/* Related News Section - Dark */}
      <div className="relative overflow-hidden bg-[#0a1628]">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <div className="relative">
          <NewsSlider dark />
        </div>
      </div>
    </>
  );
}
